"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.boldItalic = void 0;
exports.boldItalic = {
    0x2F: [.711, .21, .894],
    0x131: [.452, .008, .394, { sk: .0319 }],
    0x237: [.451, .201, .439, { sk: .0958 }],
    0x2044: [.711, .21, .894],
    0x2206: [.711, 0, .958, { sk: .192 }],
    0x29F8: [.711, .21, .894],
};
//# sourceMappingURL=bold-italic.js.map